/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { EvmTokenInfo } from './EvmTokenInfo';
import type { ListInfo } from './ListInfo';

export type HumanityAddressTokenListInfo = {
    LISTINFO: ListInfo;
    TKNT: HumanityAddressTokenListInfo.TKNT;
    TKNLIST: Array<EvmTokenInfo>;
};

export namespace HumanityAddressTokenListInfo {

    export enum TKNT {
        NA = 'NA',
        CA = 'CA',
        ERC20 = 'ERC20',
        ERC721 = 'ERC721',
        ERC1155 = 'ERC1155',
    }


}

